import { Component, NgZone, TemplateRef, ViewChild } from '@angular/core';
import { UtilService } from '../../shared/services/util.service';
import { ExcelService } from '../../shared/services/excel.service';
import { ApiService } from '../../shared/services/api.service';
import { ColDef } from 'ag-grid-community';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rate-conversion',
  templateUrl: './rate-conversion.component.html',
  standalone: false,
  styleUrls: ['./rate-conversion.component.scss']
})
export class RateConversionComponent {

  placeHolder = 'DD/MM/YYYY';
  minStart: any;
  fromDate: any = null;
  toDate: any = null;
  type = 'rates';
  excelData: any;
  excelFile: any;
  reconciliationData: any;

  // New properties for ag-grid and modal
  count = 0;
  dataObj: any = {};
  modalRef: any;
  gridApi: any;
  apiUrl: any;
  countries: any = [];
  isEdit: boolean = false;
  @ViewChild('content') content!: TemplateRef<any>;

  columnDefs: ColDef[] = [
        {
      headerName: 'Action',
      field: 'action',
      width: 80,
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        button.classList.add('btn', 'btn-sm', 'btn-primary', 'active', 'rounded-pill');
        button.innerHTML = '<i class="bi bi-eye-fill"></i>';
        button.addEventListener('click', () => this.onEdit(params));
        return button;
      },
    },
    {
      headerName: 'From Currency',
      field: 'fromCurrency',
      editable: false,
      sortable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
    },
    {
      headerName: 'To Currency',
      field: 'toCurrency',
      editable: false,
      sortable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
    },
    {
      headerName: 'Rate',
      field: 'rate',
      editable: false,
      sortable: true,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1,
        filterPlaceholder: 'Ex: 1, 71, 71.3'
      },
    },
    {
      headerName: 'Valid From',
      field: 'validFrom',
      editable: false,
      sortable: true,
      filter: false,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
      valueFormatter: (params) => {
        if (params.value) {
          return new Date(params.value).toLocaleString();
        }
        return '';
      }
    },
    {
      headerName: 'Valid To',
      field: 'validTo',
      editable: false,
      sortable: true,
      filter: false,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
      valueFormatter: (params) => {
        if (params.value) {
          return new Date(params.value).toLocaleString();
        }
        return 'Present';
      }
    },
    {
      headerName: 'Status',
      field: 'isActive',
      editable: false,
      sortable: true,
      filter: false,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
      valueFormatter: (params) => {
        return params.value ? 'Active' : 'Inactive';
      }
    },
  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };

  constructor(
    private _util: UtilService,
    private _excel: ExcelService,
    private _apiService: ApiService,
    private _modal: NgbModal,
    private zone: NgZone
  ) { }

  ngOnInit(): void {
    const vm = this;
    vm.getCountries();
  }

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {
      vm.gridApi = params.api;
      vm.gridApi.sizeColumnsToFit();
    }
  }

  refreshGrid() {
    const vm = this;
    if (vm.gridApi) {
      vm.gridApi.refreshInfiniteCache();
    }
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;

        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        if (!vm.countries?.length) {
          params.failCallback();
          return;
        }
        vm.apiUrl = '/partners/auth/get-data?type=' + vm.type + '&_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + encodeURIComponent(filterData[k].filter);
          }
        });
        if (params.sortModel && params.sortModel.length > 0) {
          const sortFields = params.sortModel.map(s => s.colId).join(',');
          const sortOrders = params.sortModel.map(s => s.sort).join(',');
          vm.apiUrl = vm.apiUrl + '&_sort=' + encodeURIComponent(sortFields) + '&_order=' + encodeURIComponent(sortOrders);
        }
        vm._apiService.getData(vm.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {

            const countryMap = new Map(
              vm.countries.map((country: any) => [
                country._id,
                country.currency?.shortName || ''
              ])
            );

            const rateData = (res.data || []).map((item: any) => ({
              ...item,

              fromCurrency:
                countryMap.get(item.from?._id) || '',

              toCurrency:
                countryMap.get(item.to?._id) || '',
            }));

            vm.count = res.count;

            params.successCallback(rateData, res.count);
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  getCountries() {
    const vm = this;
    const apiUrl = '/partners/auth/get-data?type=country&_limit=500';

    vm._apiService.getData(apiUrl).subscribe((res: any) => {
      if (res && !res.error) {

        vm.countries = (res.data || []).sort((a: any, b: any) => {
          const nameA = a?.displayName?.toLowerCase() || '';
          const nameB = b?.displayName?.toLowerCase() || '';
          return nameA.localeCompare(nameB);
        });

        if (vm.gridApi) {
          vm.gridApi.refreshInfiniteCache();
        }
      }
    });
  }

  addNew() {
    const vm = this;
    vm.dataObj = {};
    vm.isEdit = false;
    vm.modalRef = vm._modal.open(vm.content, { backdrop: 'static', size: 'lg' });
  }

  onEdit(data: any) {
    const vm = this;
    vm.zone.run(() => {
      const rateData = data.data;
      vm.dataObj = {
        _id: rateData._id,
        from: rateData.from?._id,
        to: rateData.to?._id,
        rate: rateData.rate
      };
      vm.isEdit = true;
      vm.modalRef = vm._modal.open(vm.content, { backdrop: 'static', size: 'lg' });
    });
  }

  setContent(c: any) {
    this.content = c;
  }

  onSubmit(flag: any) {
    const vm = this;
    if (!flag) {
      return;
    }
    vm.dataObj['type'] = vm.type;

    // Only send the fields that can be edited via the form
    // Let the backend handle versioning logic (validFrom, validTo, isActive)
    const reqObj: any = {
      type: vm.type,
      from: vm.dataObj.from,
      to: vm.dataObj.to,
      rate: vm.dataObj.rate
    };

    // If editing, include the ID so backend knows which rate to update
    if (vm.dataObj._id) {
      reqObj._id = vm.dataObj._id;
    }

    const apiUrl = vm.dataObj._id ? '/partners/auth/edit-data' : '/partners/auth/new-data';
    vm._apiService.postData(apiUrl, reqObj).subscribe((res: any) => {
      if (res && !res.error) {
        vm.onClose();
        vm.gridApi.refreshInfiniteCache();
      }
    });
  }

  onClose() {
    const vm = this;
    vm.modalRef.close();
  }

  onFromDate(event: any) {
    const vm = this;
    vm.minStart = vm._util.getMinFormat(event);
  }

  uploadExcel(event: any) {
    const vm = this;
    const file = event.target.files[0];
    vm.excelFile = file;
  }

  onClear() {
    const vm = this;
    vm.fromDate = null;
    vm.toDate = null;
    vm.type = null;
    vm.excelData = null;
    vm.excelFile = null;
    vm.minStart = null;
    vm.reconciliationData = null;
  }

}
